import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {User} from 'app/layout/common/user/user.types';
import {UserService} from 'app/layout/common/user/user.service';
import {AuthService} from '../../../core/auth/auth.service';

import {NgxPermissionsService} from 'ngx-permissions';
import {PERMISSIONS} from '../../../shared/contstants/permissions.const';
import {StorageUtilsService} from '../../../core/utils/storage.utils.service';
import {TreoMediaWatcherService} from '../../../../@treo/services/media-watcher';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {
    showAvatar: boolean;
    user: User;

    permissions = PERMISSIONS;
    profileLink = '/backend/profile';
    isScreenSmall = false;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {Router} _router
     * @param {UserService} _userService
     * @param _authService
     * @param permissionsService
     * @param _storageUtilsService
     * @param _treoMediaWatcherService
     * @param _route
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _authService: AuthService,
        private permissionsService: NgxPermissionsService,
        public _storageUtilsService: StorageUtilsService,
        public _treoMediaWatcherService: TreoMediaWatcherService,
        private _route: ActivatedRoute,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.showAvatar = false;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });

        this._treoMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the breakpoint is 'lt-md'
                this.isScreenSmall = matchingAliases.includes('xs');
            });

        this._route.data.subscribe((data: any) => {
            this.profileLink = data.layout === 'futuristic' ? '/backend/profile' : '/profile';
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    /**
     * Sign out
     *
     */
    signOut(): void {
        this._authService.signOut();
        this._router.navigate(['auth/sign-in']);
    }
}
